<template>
  <v-dialog v-model="visible" width="500" @keydown.esc="visible = false">
    <v-card>
      <v-card-title>
        <div class="headline">Leaving Match Transactions</div>
        <v-spacer></v-spacer>
        <v-btn text icon @click="visible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="tranType !== 'query'"> Any unsaved work will be lost. Are you sure you want to leave? </v-card-text>
      <v-card-text v-else> Are you sure you want to leave? </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="!globalLoad">
          <v-btn color="red darken-1" text @click.native="$emit('exit')">Exit</v-btn>
        </div>
        <div v-else>
          <v-btn key="loadingBtn" color="primary" text :loading="true">Loading</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  computed: {
    globalLoad() {
      // TODO ***
      return false
    }
  },
  watch: {
    value: function (value) {
      this.visible = value
    },
    visible: function (value) {
      if (!value) {
        this.$emit('input', false)
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tranMode: {
      type: String,
      default: ''
    },
    tranType: {
      type: String,
      default: ''
    }
  }
}
</script>
